module.exports = __webpack_public_path__ + "bb2.no1.76aaad88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bb2.no1.jpg
// module id = Mu4g
// module chunks = 0